import { ZixiPipelineConfig } from '@optools/services/operator-gateway/btc/types';

export function filterZixiPipelineConfigsByTerm(
  pipelineConfigs: ZixiPipelineConfig[] | undefined,
  filter: string,
) {
  if (!filter || !pipelineConfigs) return pipelineConfigs;

  const term = filter.toLowerCase();

  return pipelineConfigs.filter((item) => {
    const { teamId, zixiSources } = item;

    const zixiSourceValues =
      zixiSources?.flatMap((source) => Object.values(source).map(String)) ?? [];
    const keywords = [teamId, ...zixiSourceValues];

    return keywords.some((value) => String(value).toLowerCase().includes(term));
  });
}
